module.exports = __webpack_public_path__ + "images/2-small.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/2-small.png
 ** module id = 570
 ** module chunks = 0
 **/